/**
 * @desc 列表
 */
const URL = "/rantion-app-center";
import http, { updateResponse } from "@/http";
export type Response = defs.appCenter.ResponseDto<Array<defs.appCenter.AppDomainScopeResponseDto>>;
export function request(
  params: API.appCenter.apiScope.list.Params,
  options?: any,
): Promise<Response> {
  return updateResponse(
    http(URL + `/apiScope/list`, {
      method: "GET",
      params,

      ...options,
    }),
  );
}
